import { useGoogleLogin } from "@react-oauth/google";
import { useState } from "react";
import Button from '@mui/material/Button';

export default function GoogleAuth({ onAuthSuccess }) {
  const [user, setUser] = useState(null);

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      onAuthSuccess(tokenResponse.access_token);
      fetchUserInfo(tokenResponse.access_token);
    },
    scope: "https://www.googleapis.com/auth/photoslibrary.readonly",
    flow: "implicit", // Ensures popup login
  });

  const fetchUserInfo = async (accessToken) => {
    try {
      const response = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const data = await response.json();
      setUser(data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  return (
    <div>
      {!user && (
        <Button variant="contained" color="primary" onClick={login}>Login with Google Photos</Button>
      )}
    </div>
  );
}
